//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ClientBase from "./clientBase";
import ClientConfig from "./clientConfig";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DashboardClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDashboard(source: Source, cancelToken?: CancelToken): Promise<GetDashboardDataResponse> {
        let url_ = this.baseUrl + "/api/dashboard/{source}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboard(_response);
        });
    }

    protected processGetDashboard(response: AxiosResponse): Promise<GetDashboardDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetDashboardDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDashboardDataResponse>(null as any);
    }
}

export class DigestClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProductSyncHistory(source: Source, target: string, program: ProgramType, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfSyncDigestStats> {
        let url_ = this.baseUrl + "/api/digest/products/{source}/{target}/{program}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductSyncHistory(_response);
        });
    }

    protected processGetProductSyncHistory(response: AxiosResponse): Promise<PagedItemsResponseOfSyncDigestStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(null as any);
    }

    getProductDigest(digestId: string, cancelToken?: CancelToken): Promise<GetProductSyncResultsResponse> {
        let url_ = this.baseUrl + "/api/digest/products/{digestId}";
        if (digestId === undefined || digestId === null)
            throw new Error("The parameter 'digestId' must be defined.");
        url_ = url_.replace("{digestId}", encodeURIComponent("" + digestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDigest(_response);
        });
    }

    protected processGetProductDigest(response: AxiosResponse): Promise<GetProductSyncResultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProductSyncResultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductSyncResultsResponse>(null as any);
    }

    getCustomerSyncHistory(source: Source, target: string, program: ProgramType, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfSyncDigestStats> {
        let url_ = this.baseUrl + "/api/digest/customers/{source}/{target}/{program}?";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerSyncHistory(_response);
        });
    }

    protected processGetCustomerSyncHistory(response: AxiosResponse): Promise<PagedItemsResponseOfSyncDigestStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(null as any);
    }

    getCustomerDigest(digestId: string, cancelToken?: CancelToken): Promise<GetCustomerSyncResultsResponse> {
        let url_ = this.baseUrl + "/api/digest/customers/{digestId}";
        if (digestId === undefined || digestId === null)
            throw new Error("The parameter 'digestId' must be defined.");
        url_ = url_.replace("{digestId}", encodeURIComponent("" + digestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerDigest(_response);
        });
    }

    protected processGetCustomerDigest(response: AxiosResponse): Promise<GetCustomerSyncResultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetCustomerSyncResultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerSyncResultsResponse>(null as any);
    }
}

export class FeatureConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getFeatureConfiguration( cancelToken?: CancelToken): Promise<GetFeatureConfigurationResponse> {
        let url_ = this.baseUrl + "/api/feature-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeatureConfiguration(_response);
        });
    }

    protected processGetFeatureConfiguration(response: AxiosResponse): Promise<GetFeatureConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetFeatureConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFeatureConfigurationResponse>(null as any);
    }
}

export class PartnerConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPartnerConfiguration( cancelToken?: CancelToken): Promise<GetPartnerConfigurationResponse> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerConfiguration(_response);
        });
    }

    protected processGetPartnerConfiguration(response: AxiosResponse): Promise<GetPartnerConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConfigurationResponse>(null as any);
    }
}

export class PartnerConfigurationV2Client extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPartnerConfiguration( cancelToken?: CancelToken): Promise<GetPartnerConfigurationResponseV2> {
        let url_ = this.baseUrl + "/api/configuration/v2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerConfiguration(_response);
        });
    }

    protected processGetPartnerConfiguration(response: AxiosResponse): Promise<GetPartnerConfigurationResponseV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConfigurationResponseV2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConfigurationResponseV2>(null as any);
    }

    getConnections( cancelToken?: CancelToken): Promise<GetPartnerConnectionsResponse> {
        let url_ = this.baseUrl + "/api/configuration/v2/connections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnections(_response);
        });
    }

    protected processGetConnections(response: AxiosResponse): Promise<GetPartnerConnectionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConnectionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConnectionsResponse>(null as any);
    }
}

export class PartnersClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listPartners(search: string | null | undefined, state: ListPartnerState | null | undefined, distributor: PartnerConfigurationDistributor | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPartnerModel> {
        let url_ = this.baseUrl + "/api/partners?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (distributor !== undefined && distributor !== null)
            url_ += "Distributor=" + encodeURIComponent("" + distributor) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPartners(_response);
        });
    }

    protected processListPartners(response: AxiosResponse): Promise<PagedItemsResponseOfPartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPartnerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPartnerModel>(null as any);
    }
}

export class PartnersMigrationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMigration( cancelToken?: CancelToken): Promise<PartnerMigrationModel> {
        let url_ = this.baseUrl + "/api/partners/migration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMigration(_response);
        });
    }

    protected processGetMigration(response: AxiosResponse): Promise<PartnerMigrationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PartnerMigrationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerMigrationModel>(null as any);
    }

    updatePartnerMigrationState(migrationDetails: PatchPartnerMigrationStateModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(migrationDetails);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePartnerMigrationState(_response);
        });
    }

    protected processUpdatePartnerMigrationState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSourcePartnerConnections( cancelToken?: CancelToken): Promise<GetPartnerConnectionsResponse> {
        let url_ = this.baseUrl + "/api/partners/migration/source-partner-connections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePartnerConnections(_response);
        });
    }

    protected processGetSourcePartnerConnections(response: AxiosResponse): Promise<GetPartnerConnectionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConnectionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConnectionsResponse>(null as any);
    }

    migrateTargetConnections(targets: Target[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-target-connections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targets);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateTargetConnections(_response);
        });
    }

    protected processMigrateTargetConnections(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSourcePartnerConfiguration( cancelToken?: CancelToken): Promise<GetPartnerConfigurationResponseV2> {
        let url_ = this.baseUrl + "/api/partners/migration/source-partner-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePartnerConfiguration(_response);
        });
    }

    protected processGetSourcePartnerConfiguration(response: AxiosResponse): Promise<GetPartnerConfigurationResponseV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConfigurationResponseV2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConfigurationResponseV2>(null as any);
    }

    migrateProgramConfigurations(programMigrations: ProgramTargetMigrationModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-program-configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(programMigrations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateProgramConfigurations(_response);
        });
    }

    protected processMigrateProgramConfigurations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSourcePartnerPriceRules(skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPriceRule> {
        let url_ = this.baseUrl + "/api/partners/migration/source-partner-price-rules?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePartnerPriceRules(_response);
        });
    }

    protected processGetSourcePartnerPriceRules(response: AxiosResponse): Promise<PagedItemsResponseOfPriceRule> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPriceRule>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPriceRule>(null as any);
    }

    migratePriceRules(migrations: PriceRuleMigrationModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-price-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(migrations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigratePriceRules(_response);
        });
    }

    protected processMigratePriceRules(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSourcePartnerBillingMappings( cancelToken?: CancelToken): Promise<SourcePartnerBillingMappingModel[]> {
        let url_ = this.baseUrl + "/api/partners/migration/source-partner-billing-mappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePartnerBillingMappings(_response);
        });
    }

    protected processGetSourcePartnerBillingMappings(response: AxiosResponse): Promise<SourcePartnerBillingMappingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SourcePartnerBillingMappingModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourcePartnerBillingMappingModel[]>(null as any);
    }

    migrateBillingMappings(billingMappingMigrations: BillingMappingMigrationModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-billing-mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(billingMappingMigrations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateBillingMappings(_response);
        });
    }

    protected processMigrateBillingMappings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPsaStateMigrationStatus( cancelToken?: CancelToken): Promise<PsaStateMigrationStatus> {
        let url_ = this.baseUrl + "/api/partners/migration/psa-state-migration-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPsaStateMigrationStatus(_response);
        });
    }

    protected processGetPsaStateMigrationStatus(response: AxiosResponse): Promise<PsaStateMigrationStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PsaStateMigrationStatus>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PsaStateMigrationStatus>(null as any);
    }

    migratePsaState( cancelToken?: CancelToken): Promise<PsaStateMigrationStatus> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-psa-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigratePsaState(_response);
        });
    }

    protected processMigratePsaState(response: AxiosResponse): Promise<PsaStateMigrationStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PsaStateMigrationStatus>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PsaStateMigrationStatus>(null as any);
    }

    getSourcePartnerProductMappings( cancelToken?: CancelToken): Promise<SourcePartnerProductMappingModel[]> {
        let url_ = this.baseUrl + "/api/partners/migration/source-partner-product-mappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePartnerProductMappings(_response);
        });
    }

    protected processGetSourcePartnerProductMappings(response: AxiosResponse): Promise<SourcePartnerProductMappingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SourcePartnerProductMappingModel[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SourcePartnerProductMappingModel[]>(null as any);
    }

    migrateProductMappings(productMappingMigrations: ProductMappingMigrationModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/partners/migration/migrate-product-mappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productMappingMigrations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateProductMappings(_response);
        });
    }

    protected processMigrateProductMappings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TermsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTerms( cancelToken?: CancelToken): Promise<GetTermsDataResponse> {
        let url_ = this.baseUrl + "/api/terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTerms(_response);
        });
    }

    protected processGetTerms(response: AxiosResponse): Promise<GetTermsDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetTermsDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTermsDataResponse>(null as any);
    }

    acceptTerms(termsVersion: number, cancelToken?: CancelToken): Promise<AcceptTermsDataResponse> {
        let url_ = this.baseUrl + "/api/terms/accept/{termsVersion}";
        if (termsVersion === undefined || termsVersion === null)
            throw new Error("The parameter 'termsVersion' must be defined.");
        url_ = url_.replace("{termsVersion}", encodeURIComponent("" + termsVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptTerms(_response);
        });
    }

    protected processAcceptTerms(response: AxiosResponse): Promise<AcceptTermsDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AcceptTermsDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AcceptTermsDataResponse>(null as any);
    }

    getTermPdf(version: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/terms/getPdf?";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermPdf(_response);
        });
    }

    protected processGetTermPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CustomerMappingsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCustomerMappings(source: Source, target: string, programType: ProgramType, cancelToken?: CancelToken): Promise<CustomerMappingModel[]> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerMappings(_response);
        });
    }

    protected processGetCustomerMappings(response: AxiosResponse): Promise<CustomerMappingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CustomerMappingModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerMappingModel[]>(null as any);
    }

    saveCustomerMapping(source: Source, target: string, programType: ProgramType, command: SaveCustomerMappingCommand, cancelToken?: CancelToken): Promise<SaveCustomerMappingResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCustomerMapping(_response);
        });
    }

    protected processSaveCustomerMapping(response: AxiosResponse): Promise<SaveCustomerMappingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SaveCustomerMappingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveCustomerMappingResponse>(null as any);
    }

    getCustomerMapping(id: string, source: string, target: string, programType: string, cancelToken?: CancelToken): Promise<CustomerMappingModel> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerMapping(_response);
        });
    }

    protected processGetCustomerMapping(response: AxiosResponse): Promise<CustomerMappingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CustomerMappingModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerMappingModel>(null as any);
    }

    getTargetCustomerOptions(target: Target, billingMotion: BillingMotion, sourceCustomerId: string, sourceAgreementId: string, source: string, programType: string, cancelToken?: CancelToken): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{billingMotion}/{sourceCustomerId}/{sourceAgreementId}/target-customer-options";
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (billingMotion === undefined || billingMotion === null)
            throw new Error("The parameter 'billingMotion' must be defined.");
        url_ = url_.replace("{billingMotion}", encodeURIComponent("" + billingMotion));
        if (sourceCustomerId === undefined || sourceCustomerId === null)
            throw new Error("The parameter 'sourceCustomerId' must be defined.");
        url_ = url_.replace("{sourceCustomerId}", encodeURIComponent("" + sourceCustomerId));
        if (sourceAgreementId === undefined || sourceAgreementId === null)
            throw new Error("The parameter 'sourceAgreementId' must be defined.");
        url_ = url_.replace("{sourceAgreementId}", encodeURIComponent("" + sourceAgreementId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetCustomerOptions(_response);
        });
    }

    protected processGetTargetCustomerOptions(response: AxiosResponse): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Customer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    getTargetCustomerOptionsByMapping(id: string, source: string, target: string, programType: string, cancelToken?: CancelToken): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{id}/target-customer-options";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetCustomerOptionsByMapping(_response);
        });
    }

    protected processGetTargetCustomerOptionsByMapping(response: AxiosResponse): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Customer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    syncCustomers(source: Source, target: string, programType: ProgramType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/sync";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCustomers(_response);
        });
    }

    protected processSyncCustomers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncCustomer(source: Source, customerMappingId: string, target: string, programType: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{customerMappingId}/sync";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (customerMappingId === undefined || customerMappingId === null)
            throw new Error("The parameter 'customerMappingId' must be defined.");
        url_ = url_.replace("{customerMappingId}", encodeURIComponent("" + customerMappingId));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncCustomer(_response);
        });
    }

    protected processSyncCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    toggleCustomerMapping(source: Source, target: string, programType: ProgramType, command: ToggleCustomerMappingSyncCommand, cancelToken?: CancelToken): Promise<ToggleCustomerMappingSyncResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/togglesync";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleCustomerMapping(_response);
        });
    }

    protected processToggleCustomerMapping(response: AxiosResponse): Promise<ToggleCustomerMappingSyncResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ToggleCustomerMappingSyncResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ToggleCustomerMappingSyncResponse>(null as any);
    }

    deleteCustomerMapping(customerMappingId: string, source: string, target: string, programType: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{customerMappingId}";
        if (customerMappingId === undefined || customerMappingId === null)
            throw new Error("The parameter 'customerMappingId' must be defined.");
        url_ = url_.replace("{customerMappingId}", encodeURIComponent("" + customerMappingId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomerMapping(_response);
        });
    }

    protected processDeleteCustomerMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetCustomerMapping(customerMappingId: string, source: string, target: string, programType: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/{customerMappingId}/resetsync";
        if (customerMappingId === undefined || customerMappingId === null)
            throw new Error("The parameter 'customerMappingId' must be defined.");
        url_ = url_.replace("{customerMappingId}", encodeURIComponent("" + customerMappingId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetCustomerMapping(_response);
        });
    }

    protected processResetCustomerMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateLastProcessedInvoiceDate(source: string, target: string, programType: string, command: SetLastProcessedInvoiceDateCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/customer-mappings/lastProcessedInvoiceDate";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLastProcessedInvoiceDate(_response);
        });
    }

    protected processUpdateLastProcessedInvoiceDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProductsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    previewProductSync(source: Source, target: Target, programType: ProgramType, cancelToken?: CancelToken): Promise<GetProductSyncPreviewResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/products/preview";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewProductSync(_response);
        });
    }

    protected processPreviewProductSync(response: AxiosResponse): Promise<GetProductSyncPreviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProductSyncPreviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductSyncPreviewResponse>(null as any);
    }

    syncProducts(source: Source, target: Target, programType: ProgramType, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/products/sync";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncProducts(_response);
        });
    }

    protected processSyncProducts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateProductMapping(target: Target, mappingId: number, source: string, programType: string, targetIdData: UpdateProductMappingTargetId, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/products/mappings/{mappingId}/updateTargetId";
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (mappingId === undefined || mappingId === null)
            throw new Error("The parameter 'mappingId' must be defined.");
        url_ = url_.replace("{mappingId}", encodeURIComponent("" + mappingId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetIdData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductMapping(_response);
        });
    }

    protected processUpdateProductMapping(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProductMappings(source: Source, target: Target, programType: ProgramType, cancelToken?: CancelToken): Promise<ProductMapping[]> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/products/mappings";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMappings(_response);
        });
    }

    protected processGetProductMappings(response: AxiosResponse): Promise<ProductMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProductMapping[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMapping[]>(null as any);
    }
}

export class ProgramsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProgramConfiguration(source: Source, target: string, cancelToken?: CancelToken): Promise<GetProgramConfigurationResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProgramConfiguration(_response);
        });
    }

    protected processGetProgramConfiguration(response: AxiosResponse): Promise<GetProgramConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProgramConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProgramConfigurationResponse>(null as any);
    }

    saveProgramConfiguration(source: Source, target: string, configuration: ProgramConfigurationModel, cancelToken?: CancelToken): Promise<ProgramConfiguration> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProgramConfiguration(_response);
        });
    }

    protected processSaveProgramConfiguration(response: AxiosResponse): Promise<ProgramConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProgramConfiguration>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProgramConfiguration>(null as any);
    }

    getProgramSyncOverview(source: Source, target: string, programType: ProgramType, cancelToken?: CancelToken): Promise<GetProgramSyncOverviewResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProgramSyncOverview(_response);
        });
    }

    protected processGetProgramSyncOverview(response: AxiosResponse): Promise<GetProgramSyncOverviewResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProgramSyncOverviewResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProgramSyncOverviewResponse>(null as any);
    }

    getIsSyncInProgress(source: Source, target: string, programType: ProgramType, cancelToken?: CancelToken): Promise<GetIsCustomerSyncInProgressResponse> {
        let url_ = this.baseUrl + "/api/{source}/targets/{target}/programs/{programType}/iscustomersyncinprogress";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsSyncInProgress(_response);
        });
    }

    protected processGetIsSyncInProgress(response: AxiosResponse): Promise<GetIsCustomerSyncInProgressResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetIsCustomerSyncInProgressResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetIsCustomerSyncInProgressResponse>(null as any);
    }

    getSourcePrograms(source: Source, cancelToken?: CancelToken): Promise<GetSupportedProgramsResponse> {
        let url_ = this.baseUrl + "/api/sources/{source}/programs";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourcePrograms(_response);
        });
    }

    protected processGetSourcePrograms(response: AxiosResponse): Promise<GetSupportedProgramsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetSupportedProgramsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSupportedProgramsResponse>(null as any);
    }
}

export class SyncroConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSyncroConfiguration( cancelToken?: CancelToken): Promise<GetSyncroConfigurationResponse> {
        let url_ = this.baseUrl + "/api/targets/syncro/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncroConfiguration(_response);
        });
    }

    protected processGetSyncroConfiguration(response: AxiosResponse): Promise<GetSyncroConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetSyncroConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSyncroConfigurationResponse>(null as any);
    }

    saveSyncroConfiguration(request: SaveSyncroConfigurationRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/targets/syncro/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSyncroConfiguration(_response);
        });
    }

    protected processSaveSyncroConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConnectWiseApiProxyClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCatalogItemSubcategories( cancelToken?: CancelToken): Promise<GetConnectWiseCatalogItemSubcategoriesResponse> {
        let url_ = this.baseUrl + "/api/targets/connectwise/catalog-item-subcategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogItemSubcategories(_response);
        });
    }

    protected processGetCatalogItemSubcategories(response: AxiosResponse): Promise<GetConnectWiseCatalogItemSubcategoriesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetConnectWiseCatalogItemSubcategoriesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConnectWiseCatalogItemSubcategoriesResponse>(null as any);
    }

    getCatalogItemTypes( cancelToken?: CancelToken): Promise<GetConnectWiseCatalogItemTypesResponse> {
        let url_ = this.baseUrl + "/api/targets/connectwise/catalog-item-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogItemTypes(_response);
        });
    }

    protected processGetCatalogItemTypes(response: AxiosResponse): Promise<GetConnectWiseCatalogItemTypesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetConnectWiseCatalogItemTypesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConnectWiseCatalogItemTypesResponse>(null as any);
    }
}

export class ConnectWiseConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getConnectWiseConfiguration( cancelToken?: CancelToken): Promise<GetConnectWiseConfigurationResponse> {
        let url_ = this.baseUrl + "/api/targets/connectwise/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectWiseConfiguration(_response);
        });
    }

    protected processGetConnectWiseConfiguration(response: AxiosResponse): Promise<GetConnectWiseConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetConnectWiseConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetConnectWiseConfigurationResponse>(null as any);
    }

    saveConnectWiseConfiguration(request: SaveConnectWiseConfigurationRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/targets/connectwise/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveConnectWiseConfiguration(_response);
        });
    }

    protected processSaveConnectWiseConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AutotaskApiProxyClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getBillingCodes( cancelToken?: CancelToken): Promise<GetBillingCodesResponse> {
        let url_ = this.baseUrl + "/api/targets/autotask/billing-codes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillingCodes(_response);
        });
    }

    protected processGetBillingCodes(response: AxiosResponse): Promise<GetBillingCodesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetBillingCodesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBillingCodesResponse>(null as any);
    }

    getVendors( cancelToken?: CancelToken): Promise<GetVendorsResponse> {
        let url_ = this.baseUrl + "/api/targets/autotask/vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVendors(_response);
        });
    }

    protected processGetVendors(response: AxiosResponse): Promise<GetVendorsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetVendorsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetVendorsResponse>(null as any);
    }
}

export class AutotaskConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAutotaskConfiguration( cancelToken?: CancelToken): Promise<GetAutotaskConfigurationResponse> {
        let url_ = this.baseUrl + "/api/targets/autotask/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutotaskConfiguration(_response);
        });
    }

    protected processGetAutotaskConfiguration(response: AxiosResponse): Promise<GetAutotaskConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetAutotaskConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAutotaskConfigurationResponse>(null as any);
    }

    saveAutotaskConfiguration(request: SaveAutotaskConfigurationRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/targets/autotask/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAutotaskConfiguration(_response);
        });
    }

    protected processSaveAutotaskConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomersClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSourceCustomers(source: Source, programType: ProgramType, cancelToken?: CancelToken): Promise<Customer[]> {
        let url_ = this.baseUrl + "/api/sources/{source}/programs/{programType}/customers";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceCustomers(_response);
        });
    }

    protected processGetSourceCustomers(response: AxiosResponse): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Customer[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    getSourceCustomerAgreement(source: Source, programType: ProgramType, customerId: string, agreementId: string, cancelToken?: CancelToken): Promise<Customer> {
        let url_ = this.baseUrl + "/api/sources/{source}/programs/{programType}/customers/{customerId}/{agreementId}";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceCustomerAgreement(_response);
        });
    }

    protected processGetSourceCustomerAgreement(response: AxiosResponse): Promise<Customer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<Customer>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Customer>(null as any);
    }
}

export class SourceProductsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getSourceProducts(source: Source, programType: ProgramType, cancelToken?: CancelToken): Promise<IGetSourceProductResponse> {
        let url_ = this.baseUrl + "/api/sources/{source}/programs/{programType}/products/all";
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (programType === undefined || programType === null)
            throw new Error("The parameter 'programType' must be defined.");
        url_ = url_.replace("{programType}", encodeURIComponent("" + programType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSourceProducts(_response);
        });
    }

    protected processGetSourceProducts(response: AxiosResponse): Promise<IGetSourceProductResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<IGetSourceProductResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IGetSourceProductResponse>(null as any);
    }
}

export class PrismConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPrismConfiguration( cancelToken?: CancelToken): Promise<GetPrismConfigurationResponse> {
        let url_ = this.baseUrl + "/api/sources/prism/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrismConfiguration(_response);
        });
    }

    protected processGetPrismConfiguration(response: AxiosResponse): Promise<GetPrismConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPrismConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPrismConfigurationResponse>(null as any);
    }

    savePrismConfiguration(request: SavePrismConfigurationRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sources/prism/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePrismConfiguration(_response);
        });
    }

    protected processSavePrismConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CloudIqConfigurationClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCloudIqConfiguration( cancelToken?: CancelToken): Promise<GetCloudIqConfigurationResponse> {
        let url_ = this.baseUrl + "/api/sources/cloudiq/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCloudIqConfiguration(_response);
        });
    }

    protected processGetCloudIqConfiguration(response: AxiosResponse): Promise<GetCloudIqConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetCloudIqConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCloudIqConfigurationResponse>(null as any);
    }

    saveCloudIqConfiguration(request: SaveCloudIqConfigurationRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/sources/cloudiq/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCloudIqConfiguration(_response);
        });
    }

    protected processSaveCloudIqConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PriceRulesClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPriceRule(id: string, cancelToken?: CancelToken): Promise<PriceRule> {
        let url_ = this.baseUrl + "/api/price-rules/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceRule(_response);
        });
    }

    protected processGetPriceRule(response: AxiosResponse): Promise<PriceRule> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PriceRule>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceRule>(null as any);
    }

    getPriceRules(skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPriceRule> {
        let url_ = this.baseUrl + "/api/price-rules?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceRules(_response);
        });
    }

    protected processGetPriceRules(response: AxiosResponse): Promise<PagedItemsResponseOfPriceRule> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPriceRule>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPriceRule>(null as any);
    }

    savePriceRule(request: SavePriceRuleRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/price-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePriceRule(_response);
        });
    }

    protected processSavePriceRule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePriceRule(request: UpdatePriceRuleRequest, cancelToken?: CancelToken): Promise<UpdatePriceRuleResponse> {
        let url_ = this.baseUrl + "/api/price-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePriceRule(_response);
        });
    }

    protected processUpdatePriceRule(response: AxiosResponse): Promise<UpdatePriceRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UpdatePriceRuleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdatePriceRuleResponse>(null as any);
    }

    getAllowedActions(partnerId: string | undefined, cancelToken?: CancelToken): Promise<GetPriceRuleAllowedActionsResponse> {
        let url_ = this.baseUrl + "/api/price-rules/allowed-actions?";
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllowedActions(_response);
        });
    }

    protected processGetAllowedActions(response: AxiosResponse): Promise<GetPriceRuleAllowedActionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPriceRuleAllowedActionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPriceRuleAllowedActionsResponse>(null as any);
    }

    testPriceRule(partnerId: string | undefined, costPrice: number | undefined, retailPrice: number | undefined, rate: number | null | undefined, priceRuleAllowedActionId: string | undefined, cancelToken?: CancelToken): Promise<TestPriceRuleResponse> {
        let url_ = this.baseUrl + "/api/price-rules/test?";
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (costPrice === null)
            throw new Error("The parameter 'costPrice' cannot be null.");
        else if (costPrice !== undefined)
            url_ += "CostPrice=" + encodeURIComponent("" + costPrice) + "&";
        if (retailPrice === null)
            throw new Error("The parameter 'retailPrice' cannot be null.");
        else if (retailPrice !== undefined)
            url_ += "RetailPrice=" + encodeURIComponent("" + retailPrice) + "&";
        if (rate !== undefined && rate !== null)
            url_ += "Rate=" + encodeURIComponent("" + rate) + "&";
        if (priceRuleAllowedActionId === null)
            throw new Error("The parameter 'priceRuleAllowedActionId' cannot be null.");
        else if (priceRuleAllowedActionId !== undefined)
            url_ += "PriceRuleAllowedActionId=" + encodeURIComponent("" + priceRuleAllowedActionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestPriceRule(_response);
        });
    }

    protected processTestPriceRule(response: AxiosResponse): Promise<TestPriceRuleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TestPriceRuleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestPriceRuleResponse>(null as any);
    }
}

export class PermissionsClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPermissions( cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class DashboardAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPartnerSummaries( cancelToken?: CancelToken): Promise<AdminDashboardDataResponse> {
        let url_ = this.baseUrl + "/api/admin/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerSummaries(_response);
        });
    }

    protected processGetPartnerSummaries(response: AxiosResponse): Promise<AdminDashboardDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AdminDashboardDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminDashboardDataResponse>(null as any);
    }

    getAdminDashboard(partnerId: string, source: Source, cancelToken?: CancelToken): Promise<GetDashboardDataResponse> {
        let url_ = this.baseUrl + "/api/admin/dashboard/{partnerId}/{source}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminDashboard(_response);
        });
    }

    protected processGetAdminDashboard(response: AxiosResponse): Promise<GetDashboardDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetDashboardDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDashboardDataResponse>(null as any);
    }
}

export class FeatureConfigurationAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    updateFeatureConfiguration(request: UpdateFeatureConfigurationRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/feature-configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFeatureConfiguration(_response);
        });
    }

    protected processUpdateFeatureConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartnerConfigurationAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listPartnerConfigurations(search: string | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfGetPartnerConfigurationResponse> {
        let url_ = this.baseUrl + "/api/admin/partners/configuration?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPartnerConfigurations(_response);
        });
    }

    protected processListPartnerConfigurations(response: AxiosResponse): Promise<PagedItemsResponseOfGetPartnerConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfGetPartnerConfigurationResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfGetPartnerConfigurationResponse>(null as any);
    }

    getAdminPartnerConfiguration(partnerId: string, cancelToken?: CancelToken): Promise<GetPartnerConfigurationResponse> {
        let url_ = this.baseUrl + "/api/admin/partners/configuration/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminPartnerConfiguration(_response);
        });
    }

    protected processGetAdminPartnerConfiguration(response: AxiosResponse): Promise<GetPartnerConfigurationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetPartnerConfigurationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerConfigurationResponse>(null as any);
    }

    updatePartnerConfiguration(partnerId: string, details: PatchPartnerConfigurationDetails, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/partners/configuration/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePartnerConfiguration(_response);
        });
    }

    protected processUpdatePartnerConfiguration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartnerDigestAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAdminProductSyncHistory(partnerId: string, source: Source, target: string, program: ProgramType, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfSyncDigestStats> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/products/{source}/{target}/{program}?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminProductSyncHistory(_response);
        });
    }

    protected processGetAdminProductSyncHistory(response: AxiosResponse): Promise<PagedItemsResponseOfSyncDigestStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(null as any);
    }

    getAdminProductSyncDigest(partnerId: string, digestId: string, cancelToken?: CancelToken): Promise<GetProductSyncResultsResponse> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/products/{digestId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (digestId === undefined || digestId === null)
            throw new Error("The parameter 'digestId' must be defined.");
        url_ = url_.replace("{digestId}", encodeURIComponent("" + digestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminProductSyncDigest(_response);
        });
    }

    protected processGetAdminProductSyncDigest(response: AxiosResponse): Promise<GetProductSyncResultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProductSyncResultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductSyncResultsResponse>(null as any);
    }

    getAdminCustomerSyncHistory(partnerId: string, source: Source, target: string, program: ProgramType, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfSyncDigestStats> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/customers/{source}/{target}/{program}?";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (source === undefined || source === null)
            throw new Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        if (program === undefined || program === null)
            throw new Error("The parameter 'program' must be defined.");
        url_ = url_.replace("{program}", encodeURIComponent("" + program));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminCustomerSyncHistory(_response);
        });
    }

    protected processGetAdminCustomerSyncHistory(response: AxiosResponse): Promise<PagedItemsResponseOfSyncDigestStats> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfSyncDigestStats>(null as any);
    }

    getAdminCustomerSyncDigest(partnerId: string, digestId: string, cancelToken?: CancelToken): Promise<GetProductSyncResultsResponse> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/customers/{digestId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        if (digestId === undefined || digestId === null)
            throw new Error("The parameter 'digestId' must be defined.");
        url_ = url_.replace("{digestId}", encodeURIComponent("" + digestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdminCustomerSyncDigest(_response);
        });
    }

    protected processGetAdminCustomerSyncDigest(response: AxiosResponse): Promise<GetProductSyncResultsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetProductSyncResultsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProductSyncResultsResponse>(null as any);
    }
}

export class PartnersAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listPartners(search: string | null | undefined, state: ListPartnerState | null | undefined, distributor: PartnerConfigurationDistributor | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPartnerModel> {
        let url_ = this.baseUrl + "/api/admin/partners?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (distributor !== undefined && distributor !== null)
            url_ += "Distributor=" + encodeURIComponent("" + distributor) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPartners(_response);
        });
    }

    protected processListPartners(response: AxiosResponse): Promise<PagedItemsResponseOfPartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPartnerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPartnerModel>(null as any);
    }

    listPartnersByUserAccount(userAccountId: string, cancelToken?: CancelToken): Promise<ItemsResponseOfPartnerModel> {
        let url_ = this.baseUrl + "/api/admin/user-accounts/{userAccountId}/partners";
        if (userAccountId === undefined || userAccountId === null)
            throw new Error("The parameter 'userAccountId' must be defined.");
        url_ = url_.replace("{userAccountId}", encodeURIComponent("" + userAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPartnersByUserAccount(_response);
        });
    }

    protected processListPartnersByUserAccount(response: AxiosResponse): Promise<ItemsResponseOfPartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemsResponseOfPartnerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemsResponseOfPartnerModel>(null as any);
    }

    getPartnerDetails(partnerId: string, cancelToken?: CancelToken): Promise<PartnerModel> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerDetails(_response);
        });
    }

    protected processGetPartnerDetails(response: AxiosResponse): Promise<PartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PartnerModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerModel>(null as any);
    }

    updatePartnerDetails(partnerId: string, details: PatchPartnerDetails, cancelToken?: CancelToken): Promise<PartnerModel> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePartnerDetails(_response);
        });
    }

    protected processUpdatePartnerDetails(response: AxiosResponse): Promise<PartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PartnerModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerModel>(null as any);
    }

    getPartnerMigrations(search: string | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPartnerMigrationListModel> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerMigrations(_response);
        });
    }

    protected processGetPartnerMigrations(response: AxiosResponse): Promise<PagedItemsResponseOfPartnerMigrationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPartnerMigrationListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPartnerMigrationListModel>(null as any);
    }

    addPartnerMigration(request: AddPartnerMigrationRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPartnerMigration(_response);
        });
    }

    protected processAddPartnerMigration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPartnerMigration(srcPartnerId: string, cancelToken?: CancelToken): Promise<PartnerMigrationModel> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations/{srcPartnerId}";
        if (srcPartnerId === undefined || srcPartnerId === null)
            throw new Error("The parameter 'srcPartnerId' must be defined.");
        url_ = url_.replace("{srcPartnerId}", encodeURIComponent("" + srcPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerMigration(_response);
        });
    }

    protected processGetPartnerMigration(response: AxiosResponse): Promise<PartnerMigrationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PartnerMigrationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnerMigrationModel>(null as any);
    }

    updatePartnerMigrationState(srcPartnerId: string, migrationDetails: PatchPartnerMigrationStateModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations/{srcPartnerId}";
        if (srcPartnerId === undefined || srcPartnerId === null)
            throw new Error("The parameter 'srcPartnerId' must be defined.");
        url_ = url_.replace("{srcPartnerId}", encodeURIComponent("" + srcPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(migrationDetails);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePartnerMigrationState(_response);
        });
    }

    protected processUpdatePartnerMigrationState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deletePartnerMigration(srcPartnerId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations/{srcPartnerId}";
        if (srcPartnerId === undefined || srcPartnerId === null)
            throw new Error("The parameter 'srcPartnerId' must be defined.");
        url_ = url_.replace("{srcPartnerId}", encodeURIComponent("" + srcPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePartnerMigration(_response);
        });
    }

    protected processDeletePartnerMigration(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    listTargetPartners(search: string | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfPartnerModel> {
        let url_ = this.baseUrl + "/api/admin/partners/migrations/available-target-partners?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListTargetPartners(_response);
        });
    }

    protected processListTargetPartners(response: AxiosResponse): Promise<PagedItemsResponseOfPartnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfPartnerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfPartnerModel>(null as any);
    }
}

export class RoleAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listRoles( cancelToken?: CancelToken): Promise<ItemsResponseOfRoleModel> {
        let url_ = this.baseUrl + "/api/admin/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRoles(_response);
        });
    }

    protected processListRoles(response: AxiosResponse): Promise<ItemsResponseOfRoleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemsResponseOfRoleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemsResponseOfRoleModel>(null as any);
    }
}

export class TermsAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTermPdf(version: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/admin/terms/getPdf?";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermPdf(_response);
        });
    }

    protected processGetTermPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTermsAdmin( cancelToken?: CancelToken): Promise<ListTermsResponse> {
        let url_ = this.baseUrl + "/api/admin/terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsAdmin(_response);
        });
    }

    protected processGetTermsAdmin(response: AxiosResponse): Promise<ListTermsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListTermsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListTermsResponse>(null as any);
    }

    createTerms(forced: boolean | undefined, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<CreateNewTermsDataResponse> {
        let url_ = this.baseUrl + "/api/admin/terms?";
        if (forced === null)
            throw new Error("The parameter 'forced' cannot be null.");
        else if (forced !== undefined)
            url_ += "forced=" + encodeURIComponent("" + forced) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTerms(_response);
        });
    }

    protected processCreateTerms(response: AxiosResponse): Promise<CreateNewTermsDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CreateNewTermsDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateNewTermsDataResponse>(null as any);
    }
}

export class UserAccountAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listUserAccounts(search: string | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedItemsResponseOfUserAccountModel> {
        let url_ = this.baseUrl + "/api/admin/user-accounts?";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUserAccounts(_response);
        });
    }

    protected processListUserAccounts(response: AxiosResponse): Promise<PagedItemsResponseOfUserAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PagedItemsResponseOfUserAccountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedItemsResponseOfUserAccountModel>(null as any);
    }

    listUserAccountsByPartnerConfiguration(partnerId: string, cancelToken?: CancelToken): Promise<ItemsResponseOfUserAccountModel> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/user-accounts";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUserAccountsByPartnerConfiguration(_response);
        });
    }

    protected processListUserAccountsByPartnerConfiguration(response: AxiosResponse): Promise<ItemsResponseOfUserAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemsResponseOfUserAccountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemsResponseOfUserAccountModel>(null as any);
    }

    getUserAccount(userAccountId: string, cancelToken?: CancelToken): Promise<UserAccountModel> {
        let url_ = this.baseUrl + "/api/admin/user-accounts/{userAccountId}";
        if (userAccountId === undefined || userAccountId === null)
            throw new Error("The parameter 'userAccountId' must be defined.");
        url_ = url_.replace("{userAccountId}", encodeURIComponent("" + userAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAccount(_response);
        });
    }

    protected processGetUserAccount(response: AxiosResponse): Promise<UserAccountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserAccountModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountModel>(null as any);
    }
}

export class UserAccountRoleAdminClient extends ClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    listUserAccountRolesByUserAccount(userAccountId: string, cancelToken?: CancelToken): Promise<ItemsResponseOfUserAccountRoleModel> {
        let url_ = this.baseUrl + "/api/admin/user-accounts/{userAccountId}/roles";
        if (userAccountId === undefined || userAccountId === null)
            throw new Error("The parameter 'userAccountId' must be defined.");
        url_ = url_.replace("{userAccountId}", encodeURIComponent("" + userAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUserAccountRolesByUserAccount(_response);
        });
    }

    protected processListUserAccountRolesByUserAccount(response: AxiosResponse): Promise<ItemsResponseOfUserAccountRoleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemsResponseOfUserAccountRoleModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemsResponseOfUserAccountRoleModel>(null as any);
    }

    createUserAccountRole(userAccountId: string, model: PostUserAccountRoleDetails, cancelToken?: CancelToken): Promise<UserAccountRoleModel> {
        let url_ = this.baseUrl + "/api/admin/user-accounts/{userAccountId}/roles";
        if (userAccountId === undefined || userAccountId === null)
            throw new Error("The parameter 'userAccountId' must be defined.");
        url_ = url_.replace("{userAccountId}", encodeURIComponent("" + userAccountId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserAccountRole(_response);
        });
    }

    protected processCreateUserAccountRole(response: AxiosResponse): Promise<UserAccountRoleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserAccountRoleModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAccountRoleModel>(null as any);
    }

    listUserAccountRolesByPartner(partnerId: string, cancelToken?: CancelToken): Promise<ItemsResponseOfUserAccountRoleModel> {
        let url_ = this.baseUrl + "/api/admin/partners/{partnerId}/roles";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUserAccountRolesByPartner(_response);
        });
    }

    protected processListUserAccountRolesByPartner(response: AxiosResponse): Promise<ItemsResponseOfUserAccountRoleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ItemsResponseOfUserAccountRoleModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ItemsResponseOfUserAccountRoleModel>(null as any);
    }

    deleteUserAccountRole(userAccountRoleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/admin/user-account-roles/{userAccountRoleId}";
        if (userAccountRoleId === undefined || userAccountRoleId === null)
            throw new Error("The parameter 'userAccountRoleId' must be defined.");
        url_ = url_.replace("{userAccountRoleId}", encodeURIComponent("" + userAccountRoleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserAccountRole(_response);
        });
    }

    protected processDeleteUserAccountRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface GetDashboardDataResponse {
    programs: DashboardProgram[];
}

export interface DashboardProgram {
    target: string;
    program: SupportedProgram;
    customerOverview: CustomerSyncOverview;
    productStats: SyncDigestStats;
}

export interface SupportedProgram {
    id: string;
    name: string;
    programType: ProgramType;
}

export enum ProgramType {
    MicrosoftCsp = "MicrosoftCsp",
}

export interface CustomerSyncOverview {
    lastSyncAt: Date | undefined;
    errorMessage: string | undefined;
    totalCustomers: number;
    upToDateCustomers: number;
    mostRecentInvoiceNumber: string | undefined;
    mostRecentInvoiceApprovalDate: Date | undefined;
    errorCount: number;
    warningCount: number;
}

export interface SyncDigestStats {
    when: Date | undefined;
    errorCount: number | undefined;
    warningCount: number | undefined;
    syncCount: number | undefined;
    secondarySyncCount: number | undefined;
    digestId: string | undefined;
    errorMessage: string | undefined;
    invoices: string[];
}

export enum Source {
    Unsupported = "Unsupported",
    Prism = "Prism",
    CloudIq = "CloudIq",
}

export interface ItemsResponseOfSyncDigestStats {
    items: SyncDigestStats[];
}

export interface PagedItemsResponseOfSyncDigestStats extends ItemsResponseOfSyncDigestStats {
    paging: PagingModel;
}

export interface PagingModel {
    skip: number;
    take: number;
    count: number;
}

export interface GetProductSyncResultsResponse {
    program: string;
    target: string;
    stats: SyncDigestStats;
    digest: ProductSyncDigest;
}

export interface ProductSyncDigest {
    wasSuccessful: boolean;
    exception: string | undefined;
    results: ProductSyncResult[];
}

export interface ProductSyncResult {
    sourceProduct: Product | undefined;
    targetProduct: Product | undefined;
    outcome: SyncOutcome;
    errorMessage: string | undefined;
    updates: UpdateResult[] | undefined;
}

export interface ProductBase {
    id: string;
    name: string;
    sku: string;
    billingCycle: BillingCycle | undefined;
    billingTerm: string | undefined;
    billingTermDuration: number | undefined;
}

export interface Product extends ProductBase {
    vendorSku: string;
    description: string | undefined;
    costUnitPrice: number;
    retailUnitPrice: number;
    productRestrictions: string | undefined;
    unit: string | undefined;
    isTaxable: boolean;
    isNewCommerceExperience: boolean;
    offeringIdentifier: string;
    isTrialProduct: boolean;
}

export enum BillingCycle {
    Unknown = "Unknown",
    Monthly = "Monthly",
    Annual = "Annual",
    None = "None",
    OnceOff = "OnceOff",
}

export enum SyncOutcome {
    Created = "Created",
    Updated = "Updated",
    NoChange = "NoChange",
    Error = "Error",
    Exists = "Exists",
    Warning = "Warning",
}

export interface UpdateResult {
    fieldName: string;
    newValue: any;
}

export interface GetCustomerSyncResultsResponse {
    program: string;
    target: string;
    stats: SyncDigestStats;
    digest: CustomerSyncDigest;
}

export interface CustomerSyncDigest {
    wasSuccessful: boolean;
    exception: string | undefined;
    results: CustomerSyncResult[];
}

export interface CustomerSyncResult {
    customerMappingId: string;
    errorMessage: string | undefined;
    subscriptionSyncResults: SubscriptionSyncResult[];
    sourceCustomer: SourceCustomerForSync | undefined;
    targetCustomer: Customer | undefined;
    hasAdditionalInvoicesToProcess: boolean;
    outcome: SyncOutcome;
}

export interface SubscriptionSyncResult {
    sourceSubscription: Subscription;
    usageRecordSyncResults: SubscriptionUsageRecordSyncResult[];
    outcome: SyncOutcome;
}

export interface Subscription {
    id: string | undefined;
    productId: string | undefined;
    productSku: string | undefined;
    productName: string | undefined;
    billingCycle: BillingCycle | undefined;
    termDurationUnit: string | undefined;
    termDuration: number | undefined;
    isNewCommerceExperience: boolean;
    usage: UsageRecord[] | undefined;
}

export interface UsageRecord {
    costUnitPrice: number;
    retailUnitPrice: number;
    quantity: number;
    startDate: Date;
    endDate: Date | undefined;
    id: string | undefined;
    externalIdentifier: string | undefined;
    usagePriceRule: UsagePriceRule | undefined;
    isAzure: boolean;
    isFee: boolean;
    classification: UsageRecordClassification;
}

export interface UsagePriceRule {
    id: string | undefined;
    rate: number | undefined;
    allowedAction: string | undefined;
}

export enum UsageRecordClassification {
    None = "None",
    MissedUsage = "MissedUsage",
    CiqRetailPriceFallbackToCostPrice = "CiqRetailPriceFallbackToCostPrice",
}

export interface SubscriptionUsageRecordSyncResult {
    sourceUsageRecord: UsageRecord;
    targetSubscription: Subscription | undefined;
    outcome: SyncOutcome;
    errorMessage: string | undefined;
    warnings: string[];
    operations: SyncOperation[] | undefined;
}

export interface SyncOperation {
    operationDescription: string;
    id: string | undefined;
    data: any | undefined;
}

export interface SourceCustomerForSync {
    id: string | undefined;
    name: string | undefined;
    agreement: Agreement;
    invoiceNumber: string | undefined;
    invoiceDate: Date | undefined;
    invoiceUsageStartDate: Date | undefined;
    hasAdditionalInvoicesToProcess: boolean;
    invoiceHasBeenModified: boolean;
}

export interface Agreement {
    id: string | undefined;
    name: string | undefined;
    subscriptions: Subscription[] | undefined;
    billingType: string | undefined;
}

export interface Customer {
    id: string;
    name: string | undefined;
    domain: string | undefined;
    agreements: Agreement[];
}

export interface GetFeatureConfigurationResponse {
    flags: number;
}

export interface GetPartnerConfigurationResponse {
    id: string;
    name: string | undefined;
    isCompliant: boolean;
    termsVersion: number;
    authorizedSources: number;
    configuredSources: { [key in keyof typeof Source]?: boolean; };
    authorizedTargets: number;
    configuredTargets: { [key in keyof typeof Target]?: boolean; };
    configuredPrograms: { [key in keyof typeof Source]?: { [key in keyof typeof Target]?: { [key in keyof typeof ProgramType]?: ConfiguredProgram; }; }; } | undefined;
}

export enum Target {
    Unsupported = "Unsupported",
    ConnectWise = "ConnectWise",
    Autotask = "Autotask",
    Syncro = "Syncro",
}

export interface ConfiguredProgram {
    target: string;
    type: ProgramType;
    name: string;
    status: ProgramStatus;
}

export enum ProgramStatus {
    NotConfigured = "NotConfigured",
    Syncing = "Syncing",
    NotSyncing = "NotSyncing",
}

export interface GetPartnerConfigurationResponseV2 {
    partnerId: string;
    partnerName: string | undefined;
    configuredSources: { [key in keyof typeof Source]?: boolean; };
    configuredTargets: { [key in keyof typeof Target]?: boolean; };
    configuredPrograms: ConfiguredProgramsV2[];
}

export interface ConfiguredProgramsV2 {
    source: Source;
    target: Target;
    programs: ProgramV2[];
}

export interface ProgramV2 {
    type: ProgramType;
    name: string;
    status: ProgramStatus;
    isBillingSyncing: boolean;
    isProductsSyncing: boolean;
    activeBillingMotions: BillingMotion;
}

export enum BillingMotion {
    None = "None",
    SeatBased = "SeatBased",
    AzureClassic = "AzureClassic",
    AzurePlan = "AzurePlan",
    AzureReservedInstance = "AzureReservedInstance",
    PerpetualSoftware = "PerpetualSoftware",
    SoftwareSubscription = "SoftwareSubscription",
    LicenseBasedAzureMarketplace = "LicenseBasedAzureMarketplace",
    AzureSavingsPlan = "AzureSavingsPlan",
    SeatBasedAnnual = "SeatBasedAnnual",
}

export interface GetPartnerConnectionsResponse {
    configuredSources: { [key in keyof typeof Source]?: ConnectionState; };
    configuredTargets: { [key in keyof typeof Target]?: ConnectionState; };
}

export enum ConnectionState {
    Connected = "Connected",
    NotConnected = "NotConnected",
    RequestAccess = "RequestAccess",
}

export interface ItemsResponseOfPartnerModel {
    items: PartnerModel[];
}

export interface PagedItemsResponseOfPartnerModel extends ItemsResponseOfPartnerModel {
    paging: PagingModel;
}

export interface PartnerModel {
    id: string;
    name: string | undefined;
    state: PartnerState;
    distributor: PartnerConfigurationDistributor;
    acceptedTerms: TermsAcceptance[] | undefined;
}

export enum PartnerState {
    Active = "Active",
    Inactive = "Inactive",
}

export enum PartnerConfigurationDistributor {
    Crayon = "Crayon",
    Rhipe = "Rhipe",
}

export interface TermsAcceptance {
    termsVersion: number;
    acceptedByName: string;
    acceptedByEmail: string;
    acceptedDate: Date | undefined;
}

export enum ListPartnerState {
    All = "All",
    Active = "Active",
    Inactive = "Inactive",
}

export interface PartnerMigrationModel {
    sourcePartner: PartnerModel;
    targetPartner: PartnerModel;
    state: PartnerMigrationState;
}

export enum PartnerMigrationState {
    NotStarted = "NotStarted",
    SourceConnection = "SourceConnection",
    TargetConnections = "TargetConnections",
    Programs = "Programs",
    PriceRules = "PriceRules",
    ProductMappings = "ProductMappings",
    BillingMappings = "BillingMappings",
    PSAsUsageState = "PSAsUsageState",
    Completed = "Completed",
}

export interface PatchPartnerMigrationStateModel {
    state: PartnerMigrationState;
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export interface ProgramTargetMigrationModel {
    programType: ProgramType;
    target: Target;
}

export interface ItemsResponseOfPriceRule {
    items: PriceRule[];
}

export interface PagedItemsResponseOfPriceRule extends ItemsResponseOfPriceRule {
    paging: PagingModel;
}

export interface PriceRule {
    id: string;
    program: string | undefined;
    productSku: string | undefined;
    productName: string | undefined;
    source: Source | undefined;
    sourceCustomerId: string | undefined;
    sourceCustomerName: string | undefined;
    rate: number | undefined;
    priceRuleAllowedAction: IPriceRuleAllowedAction;
    startDateUtc: Date;
    endDateUtc: Date | undefined;
    lastModifiedDateUtc: Date | undefined;
    status: PriceRuleStatus;
}

export interface IPriceRuleAllowedAction {
    id: string;
    pricingField: PricingField;
    pricingAction: PricingAction;
    isProfitMarginRule: boolean;
    isAddition: boolean;
    isPercentage: boolean;
    display: string;
}

export enum PricingField {
    Retail = "Retail",
    Cost = "Cost",
}

export enum PricingAction {
    At = "At",
    FixedOn = "FixedOn",
    FixedOff = "FixedOff",
    PercentageOn = "PercentageOn",
    PercentageOff = "PercentageOff",
    MarginPercentageOn = "MarginPercentageOn",
    MarginPercentageOff = "MarginPercentageOff",
}

export enum PriceRuleStatus {
    Unknown = "Unknown",
    Active = "Active",
    Expired = "Expired",
    Future = "Future",
}

export interface PriceRuleMigrationModel {
    id: string;
    sourceCustomerId: string | undefined;
    sourceCustomerName: string | undefined;
}

export interface SourcePartnerBillingMappingModel {
    id: string;
    target: Target;
    sourceCustomer: MappingCustomer;
    targetCustomer: MappingCustomer;
    billingMotion: BillingMotion;
    isSyncing: boolean;
    isTargetCustomerAgreementInUse: boolean;
    assignedCiqCustomerId: string | undefined;
}

export interface MappingCustomer {
    id: string | undefined;
    name: string | undefined;
    agreement: Agreement | undefined;
}

export interface BillingMappingMigrationModel {
    billingMappingId: string;
    cloudIqCustomerId: string;
}

export enum PsaStateMigrationStatus {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Completed = "Completed",
}

export interface SourcePartnerProductMappingModel {
    target: Target;
    mappingId: number;
    sku: string;
    sourceName: string;
    targetName: string;
    targetId: number;
    targetType: TargetProductType;
    offeringTerm: string;
}

export enum TargetProductType {
    Product = "Product",
    Service = "Service",
}

export interface ProductMappingMigrationModel {
    target: Target;
    targetType: TargetProductType;
    mappingId: number;
    cloudIqProductId: string;
    cloudIqProductSku: string;
}

export interface GetTermsDataResponse {
    version: number;
    partnerAlreadyAccepted: boolean;
}

export interface AcceptTermsDataResponse {
    accepted: boolean;
}

export interface CustomerMappingModel {
    id: string | undefined;
    programType: ProgramType;
    sourceCustomer: MappingCustomer;
    targetCustomer: MappingCustomer | undefined;
    isSyncing: boolean;
    startSyncDate: Date | undefined;
    lastSuccessfulSync: Date | undefined;
    lastSync: Date | undefined;
    isLastSyncError: boolean;
    isLastSyncSuccess: boolean;
    hasNoInitialSync: boolean;
    lastProcessedInvoice: string | undefined;
    lastProcessedInvoiceApprovalDate: Date | undefined;
    warnings: string[] | undefined;
    errorMessage: string | undefined;
    sourceAgreementMissing: boolean;
    targetAgreementMissing: boolean;
    pricingSyncStrategy: PricingSyncStrategy;
    billingMotion: BillingMotion;
    flags: CustomerMappingFlag;
}

export enum PricingSyncStrategy {
    CostAndRetailPricing = "CostAndRetailPricing",
    CostPricing = "CostPricing",
    NoPricing = "NoPricing",
    NoPricingOnUpdate = "NoPricingOnUpdate",
}

export enum CustomerMappingFlag {
    Empty = "Empty",
    MigrationInProgress = "MigrationInProgress",
}

export interface SaveCustomerMappingResponse {
    id: string;
}

export interface SaveCustomerMappingCommand {
    id: string | undefined;
    partnerId: string;
    target: string;
    source: Source;
    programType: ProgramType;
    sourceCustomerId: string;
    sourceAgreementId: string;
    targetCustomerId: string;
    targetAgreementId: string;
    isSyncing: boolean;
    startSyncDate: Date | undefined;
    pricingSyncStrategy: PricingSyncStrategy;
    billingMotion: BillingMotion;
}

export interface ToggleCustomerMappingSyncResponse {
    isSyncing: boolean;
}

export interface ToggleCustomerMappingSyncCommand {
    id: string;
    partnerId: string;
    source: Source;
    target: string;
    programType: ProgramType;
}

export interface SetLastProcessedInvoiceDateCommand {
    partnerId: string;
    customerMappingId: string;
    lastProcessedInvoiceDate: Date | undefined;
}

export interface GetProductSyncPreviewResponse {
    errorMessage: string | undefined;
    mappedProducts: MappedProduct[] | undefined;
}

export interface MappedProduct {
    mappingId: number | undefined;
    sku: string;
    sourceName: string;
    targetName: string | undefined;
    billingCycle: BillingCycle | undefined;
    billingTerm: string | undefined;
    billingTermDuration: number | undefined;
    targetId: string | undefined;
    hasError: boolean;
    targetType: number | undefined;
}

export interface UpdateProductMappingTargetId {
    targetId: number;
    targetType: TargetProductType;
}

export interface ProductMapping {
    id: number;
    sku: string | undefined;
    sourceName: string | undefined;
    targetName: string | undefined;
    billingCycle: BillingCycle;
    billingTerm: string | undefined;
    billingTermDuration: number;
    targetId: number;
    targetType: TargetProductType;
}

export interface GetProgramConfigurationResponse {
    supportedPrograms: SupportedProgram[];
    configurations: ProgramConfiguration[];
}

export interface ProgramConfigurationBase {
    emails: string[];
    programType: ProgramType;
    isSyncing: boolean;
    isBillingSyncing: boolean;
    isProductsSyncing: boolean;
    productSyncMode: ProductSyncMode;
    productSyncBillingMode: ProductSyncBillingMode;
    activeBillingMotions: BillingMotion;
}

export interface ProgramConfiguration extends ProgramConfigurationBase {
    configuration: IProgramConfigurationData;
}

export interface IProgramConfigurationData {
    syncAzure: boolean;
    syncAnnualBilled: boolean;
    ciqRetailPriceSource: CloudIqRetailPriceSource;
}

export enum CloudIqRetailPriceSource {
    Erp = "Erp",
    ResellerSalesPrice = "ResellerSalesPrice",
}

export enum ProductSyncMode {
    AllProducts = "AllProducts",
    InUseProductsOnly = "InUseProductsOnly",
}

export enum ProductSyncBillingMode {
    None = "None",
    MonthlyBillingMonthlyTerm = "MonthlyBillingMonthlyTerm",
    MonthlyBillingAnnualTerm = "MonthlyBillingAnnualTerm",
    AnnualBillingAnnualTerm = "AnnualBillingAnnualTerm",
}

export interface GetProgramSyncOverviewResponse {
    overview: ProgramSyncOverview;
}

export interface ProgramSyncOverview {
    programName: string;
    targetOverview: ITargetSyncOverview;
    customerSync: CustomerSyncOverview;
    productSync: SyncDigestStats;
}

export interface ITargetSyncOverview {
}

export interface ProgramConfigurationModel extends ProgramConfigurationBase {
    configuration: any;
}

export interface GetIsCustomerSyncInProgressResponse {
    isInProgress: boolean;
}

export interface GetSyncroConfigurationResponse {
    companyUrl: string;
}

export interface SaveSyncroConfigurationRequestModel {
    companyUrl: string;
    apiToken: string;
}

export interface GetConnectWiseCatalogItemSubcategoriesResponse {
    items: SubcategoryModel[];
}

export interface IdNameField {
    id: number;
    name: string | undefined;
}

export interface SubcategoryModel extends IdNameField {
    category: IdNameField;
}

export interface GetConnectWiseCatalogItemTypesResponse {
    items: IdNameField[];
}

export interface GetConnectWiseConfigurationResponse {
    site: string;
    companyId: string;
    restApiPublicKey: string;
}

export interface SaveConnectWiseConfigurationRequestModel {
    site: string;
    companyId: string;
    restApiPublicKey: string;
    restApiPrivateKey: string;
}

export interface GetBillingCodesResponse {
    items: BillingCodeDetail[];
}

export interface BillingCodeDetail {
    id: number;
    name: string;
}

export interface GetVendorsResponse {
    items: CompanyDetail[];
}

export interface CompanyDetail {
    id: number;
    companyName: string;
}

export interface GetAutotaskConfigurationResponse {
    username: string;
    zoneUrl: string;
}

export interface SaveAutotaskConfigurationRequestModel {
    username: string;
    secret: string;
}

export interface IGetSourceProductResponse {
    products: Product[];
}

export interface GetSupportedProgramsResponse {
    supportedPrograms: SupportedProgram[];
}

export interface GetPrismConfigurationResponse {
    clientId: string;
}

export interface SavePrismConfigurationRequestModel {
    clientId: string;
    clientSecret: string;
}

export interface GetCloudIqConfigurationResponse {
    clientId: string;
    organizationId: number;
    clientUsername: string;
}

export interface SaveCloudIqConfigurationRequestModel {
    clientId: string;
    clientSecret: string;
    username: string;
    password: string;
    organizationId: number;
}

export interface GetPriceRuleAllowedActionsResponse {
    priceRuleAllowedActions: IPriceRuleAllowedAction[];
}

export interface SavePriceRuleRequest {
    id: string | undefined;
    partnerId: string;
    program: string | undefined;
    productSku: string | undefined;
    productName: string | undefined;
    source: Source | undefined;
    sourceCustomerId: string | undefined;
    sourceCustomerName: string | undefined;
    priceRuleAllowedAction: PriceRuleAllowedAction;
    rate: number | undefined;
    startDateUtc: Date;
    endDateUtc: Date | undefined;
}

export interface PriceRuleAllowedAction {
    id: string;
    pricingField: PricingField;
    pricingAction: PricingAction;
    display: string;
    isProfitMarginRule: boolean;
    isAddition: boolean;
    isPercentage: boolean;
}

export interface UpdatePriceRuleResponse {
}

export interface UpdatePriceRuleRequest {
    id: string | undefined;
    partnerId: string;
    program: string | undefined;
    productSku: string | undefined;
    productName: string | undefined;
    source: Source | undefined;
    sourceCustomerId: string | undefined;
    sourceCustomerName: string | undefined;
    priceRuleAllowedAction: PriceRuleAllowedAction;
    rate: number | undefined;
    startDateUtc: Date;
    endDateUtc: Date | undefined;
}

export interface TestPriceRuleResponse {
    customerPrice: number;
    margin: number;
}

export interface AdminDashboardDataResponse {
    partnerSummaries: PartnerSummary[];
}

export interface PartnerSummary {
    category: string;
    totalPartners: number;
    totalCustomerSyncs: number;
}

export interface UpdateFeatureConfigurationRequest {
    flags: FeatureFlags;
}

export enum FeatureFlags {
    None = "None",
    PriceRules = "PriceRules",
}

export interface ItemsResponseOfGetPartnerConfigurationResponse {
    items: GetPartnerConfigurationResponse[];
}

export interface PagedItemsResponseOfGetPartnerConfigurationResponse extends ItemsResponseOfGetPartnerConfigurationResponse {
    paging: PagingModel;
}

export interface PatchPartnerConfigurationDetails {
    authorizedSources: Source;
    authorizedTargets: Target;
}

export interface PatchPartnerDetails {
    state: PartnerState;
}

export interface ItemsResponseOfPartnerMigrationListModel {
    items: PartnerMigrationListModel[];
}

export interface PagedItemsResponseOfPartnerMigrationListModel extends ItemsResponseOfPartnerMigrationListModel {
    paging: PagingModel;
}

export interface PartnerMigrationListModel {
    sourcePartner: PartnerModel;
    targetPartner: PartnerModel | undefined;
    state: PartnerMigrationState | undefined;
}

export interface AddPartnerMigrationRequest {
    sourcePartnerId: string;
    targetPartnerId: string;
}

export interface ItemsResponseOfRoleModel {
    items: RoleModel[];
}

export interface RoleModel {
    id: string;
    type: RoleModelType;
    value: RoleModelValue;
}

export enum RoleModelType {
    Application = "Application",
    Customer = "Customer",
}

export enum RoleModelValue {
    ApplicationAdministrator = "ApplicationAdministrator",
    CustomerAdministrator = "CustomerAdministrator",
}

export interface ListTermsResponse {
    terms: Terms[];
}

export interface Terms {
    version: number;
    uploadDate: Date;
    forced: boolean;
    createdByEmail: string | undefined;
    createdByName: string | undefined;
}

export interface CreateNewTermsDataResponse {
    termsVersion: number;
}

export interface ItemsResponseOfUserAccountModel {
    items: UserAccountModel[];
}

export interface PagedItemsResponseOfUserAccountModel extends ItemsResponseOfUserAccountModel {
    paging: PagingModel;
}

export interface UserAccountModel {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    identityProvider: UserAccountIdentityProvider;
}

export enum UserAccountIdentityProvider {
    CrayonSignIn = "CrayonSignIn",
    RhipeSignIn = "RhipeSignIn",
    MicrosoftEntra = "MicrosoftEntra",
}

export interface ItemsResponseOfUserAccountRoleModel {
    items: UserAccountRoleModel[];
}

export interface UserAccountRoleModel {
    id: string;
    userAccount: UserAccountModel;
    role: RoleModel;
    partner: PartnerModel | undefined;
}

export interface PostUserAccountRoleDetails {
    roleId: string;
    partnerId: string | undefined;
}

export enum ApiPermissionOptions {
    StaffAdministration = "StaffAdministration",
    PartnerAdministration = "PartnerAdministration",
    TermsAndConditionsAccept = "TermsAndConditionsAccept",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}